import { PRODUCTION_STAGES } from "./productionRules";

export function generateProductionTasks({ startDate, product }) {
  const tasks = [];
  let cursor = new Date(startDate);

  PRODUCTION_STAGES.forEach((stage) => {
    const taskStart = new Date(cursor);
    const taskEnd = new Date(cursor);
    taskEnd.setDate(taskEnd.getDate() + stage.durationDays);

    tasks.push({
      id: (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `${stage.id}-${taskStart.getTime()}`,
      title: stage.label,
      stage: stage.id,
      productName: product?.name,
      productId: product?.id,
      startDate: taskStart.toISOString(),
      dueDate: taskEnd.toISOString(),
      dependsOn: stage.dependsOn,
      // never overwrite existing logic
    });

    cursor = taskEnd;
  });

  return tasks;
}
